import { Link } from 'react-router-dom'
import { useTranslation } from '../i18n'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()
  const { t } = useTranslation()

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <svg viewBox="0 0 100 100" width="32" height="32">
                <defs>
                  <linearGradient id="footerLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#6366f1" />
                    <stop offset="100%" stopColor="#8b5cf6" />
                  </linearGradient>
                </defs>
                <circle cx="50" cy="50" r="45" fill="url(#footerLogoGrad)"/>
                <path d="M35 40 L35 60 L55 50 Z" fill="white"/>
                <circle cx="70" cy="35" r="8" fill="#22c55e"/>
                <path d="M66 35 L69 38 L75 32" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{t('siteTitle')}</span>
            </Link>
            <p className="footer-tagline">
              {t('footerTagline')}
            </p>
          </div>

          <nav className="footer-links" aria-label="Product links">
            <h4>{t('footerProduct')}</h4>
            <ul>
              <li><Link to="/features">{t('navFeatures')}</Link></li>
              <li><Link to="/how-it-works">{t('navHowItWorks')}</Link></li>
              <li><Link to="/pricing">{t('navPricing')}</Link></li>
              <li><Link to="/download">{t('navDownload')}</Link></li>
              <li><Link to="/stealth">Is It Safe?</Link></li>
              <li><Link to="/compatibility">Compatibility</Link></li>
            </ul>
          </nav>

          <nav className="footer-links" aria-label="Resources">
            <h4>{t('footerResources')}</h4>
            <ul>
              <li><Link to="/privacy">{t('navPrivacy')}</Link></li>
              <li><Link to="/download">{t('navDownload')}</Link></li>
              <li><a href="mailto:support@getintervio.com">{t('footerContact')}</a></li>
            </ul>
          </nav>

          <nav className="footer-links" aria-label="Legal">
            <h4>{t('footerLegal')}</h4>
            <ul>
              <li><Link to="/privacy">{t('navPrivacy')}</Link></li>
              <li><a href="#">{t('footerTerms')}</a></li>
            </ul>
          </nav>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {t('siteTitle')}. {t('footerRights')}</p>
          <p className="footer-disclaimer">
            {t('footerDisclaimer')}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
